export default "RCT zu Yoga während Strahlentherapie bei Prostata- und Brustkrebs – Hinweise auf günstige Effekte bei Fatigue und Lebensqualität."